if (!window.requestIdleCallback) {
  window.requestIdleCallback = (callback) => {
    const start = Date.now();

    return setTimeout(() => {
      callback({
        didTimeout: false,
        timeRemaining: () => {
          return Math.max(0, 50.0 - (Date.now() - start));
        }
      });
    }, 1);
  };
}

if (!window.cancelIdleCallback) {
  window.cancelIdleCallback = (id) => {
    clearTimeout(id);
  };
}